module.exports = __webpack_public_path__ + "static/10-e88361ca0d302ad89834f7efcb92d381.jpg";